jQuery( function ($) {
    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
        const forms = document.querySelectorAll('.gform_wrapper');
        forms.forEach(form => {
            const display = form.querySelector('.signature');
            const first = form.querySelector('.firstname input')?.value?.trim() || '';
            const last = form.querySelector('.lastname input')?.value?.trim() || '';
            const address = form.querySelector('.address input')?.value?.trim() || '';
            const postal = form.querySelector('.postal input')?.value?.trim() || '';

            display.innerHTML = `${first} ${last}<br /> ${address}, ${postal}`;
        });
    });

})